<tgt-modal [witdhModal]="'80%'">
  <main>

    <h3>Criar Agenda</h3>

    <app-tabs [tabs]="steps" (change)="changeTabs($event)"></app-tabs>
    <!-- <tgt-divider></tgt-divider> -->

    @switch (tabSelected) {
    @case ('evento') {
    <div class="evento">
      <div class="infos">
        <tgt-select [valueOptionSelected]="enviarParaSelected ? enviarParaSelected : ''"
          [error]="form.controls.enviarPara.value === '' ? campoObrigatorio : false" [label]="'Enviar Para*'"
          [options]="optionsPerfis" [control]="form.controls.enviarPara"></tgt-select>
        @if(this.form.controls.enviarPara.value === 'Pais' ) {
        <div class="turmas">
          <tgt-select [options]="optionTurmas" (changeOption)="changeTurmaOption($event)"
            [disabled]="this.form.controls.enviarTodasTurmas.value ? true : false" [label]="'Turma*'"></tgt-select>
          <tgt-checkbox [checked]="todasTurmas" (checkedChange)="changeTurmas($event)">Todas</tgt-checkbox>
        </div>
        <div class="chips">
          @for (item of idsTurmas; track item; let posicao = $index) {
          <chips-selects (clicked)="removerTurma(posicao)" [mode]="'outline'" [label]="item.label"></chips-selects>
          }
        </div>
        }
        <tgt-input-icon [error]="form.controls.dataLembrete.value === '' ? campoObrigatorio : false" [icon]="'search'" [type]="'date'"
          [border]="true" [placeholder]="'Data de Notificação*'"
          [control]="form.controls.dataLembrete"></tgt-input-icon>
        <tgt-select [valueOptionSelected]="categoriaSelected ? categoriaSelected : ''"
          [error]="form.controls.categoria.value === '' ? campoObrigatorio : false" [label]="'Categoria*'"
          [options]="optionsCategoria" [control]="form.controls.categoria"></tgt-select>
        <tgt-divider class="mt-2"></tgt-divider>
        <tgt-input-icon [error]="form.controls.data.value === '' ? campoObrigatorio : false"
          [border]="true" [placeholder]="'Data do evento*'" [icon]="'search'" [type]="'date'"
          [control]="form.controls.data"></tgt-input-icon>

        <div class="cont-sec">
          <div class="check">
            <tgt-checkbox [checked]="diaInteiro" (checkedChange)="change($event)">Dia Inteiro</tgt-checkbox>
            <!-- <tgt-select-color [control]="form.controls.color"></tgt-select-color> -->
          </div>
        </div>


        @if(!form.controls.diaInteiro.value) {
        <div class="horas">
          <tgt-input-icon [border]="true" [placeholder]="'Hora Início *'"
            [control]="form.controls.horaInicio" [type]="'time'"></tgt-input-icon>
          <tgt-input-icon [border]="true" [placeholder]="'Hora Fim *'" [control]="form.controls.horaFim"
             [type]="'time'"></tgt-input-icon>
        </div>
        }

      </div>
      <div class="descricao">
        <tgt-input-icon [error]="form.controls.assunto.value === '' ? campoObrigatorio : false" [border]="true"
          [placeholder]="'Assunto*'" [icon]="'description'" [control]="form.controls.assunto"></tgt-input-icon>
        <tgt-textarea [error]="form.controls.descricao.value === '' ? campoObrigatorio : false" [linhas]="19"
          [placeholder]="'Texto a ser enviado'" [control]="form.controls.descricao"></tgt-textarea>

      </div>
    </div>
    }
    @case('arquivo') {
    <div class="evento">
      <div class="documento">
        <div class="doc">
          <input type="file" multiple hidden #abrir (change)="salvarArquivo($event)">
          <span class="material-symbols-outlined" (click)="abrir.click()">
            upload
          </span>
        </div>
        <div class="infos">
          @if(files.length > 0) {
            <span>{{files.length}} arquivo(s) selecionado(s)</span>
          } @else {
            <span>Clique para carregar</span>
            <p>Tamanho máximo do arquivo: 200MB</p>
            <p>Tipos suportados: Imagens, Documentos, Vídeos, Áudios</p>
          }
        </div>
      </div>

      <!-- Lista de arquivos selecionados -->
      @if(files.length > 0) {
        <div class="arquivos-lista">
          <h4>Arquivos Selecionados:</h4>
          @for (file of files; track file.name; let index = $index) {
            <div class="arquivo-item">
              <div class="arquivo-info">
                <span class="material-symbols-outlined">description</span>
                <div class="arquivo-detalhes">
                  <span class="arquivo-nome">{{file.name}}</span>
                  <span class="arquivo-tamanho">{{(file.size / (1024 * 1024)).toFixed(2)}} MB</span>
                </div>
              </div>
              <div class="arquivo-acoes">
                <span class="material-symbols-outlined" (click)="removerArquivo(index)">
                  delete
                </span>
              </div>
            </div>
          }
        </div>
      }
    </div>
    }
    }


    @if (!data?.id) {
    <div class="action">
      <tgt-button [border]="false" [color]="'primary'" [size]="'small'" (click)="cancelar()"
        [fieldButton]="'outline'">Cancelar</tgt-button>
      <tgt-button [color]="'primary'" [fieldButton]="'field'" (click)="agendar()" [icon]="'add'">Agendar</tgt-button>
    </div>
    }

  </main>
</tgt-modal>
